<template>
  <div>
    <a-dropdown :trigger="['click']" v-model="show">
      <div slot="overlay">
        <a-spin :spinning="loading">
          <a-tabs class="dropdown-tabs" :tabBarStyle="{textAlign: 'center'}" :style="{width: '297px'}">
            <a-tab-pane tab="消息提醒" key="1">
              <a-list class="tab-pane">
                <a-list-item v-for="(item,i) in noticeList" v-bind:key="i">
                  <a-list-item-meta :title="item.objTypeName" :description="item.taskContent"
                                    @click="taskPromptDetail(item)"></a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-tab-pane>
          </a-tabs>
        </a-spin>
      </div>
      <span @click="fetchNotice" class="header-notice">
      <a-badge class="notice-badge" :count="noticeCount">
        <a-icon :class="['header-notice-icon']" type="bell" :style="{color: '#000'}"/>
      </a-badge>
    </span>
    </a-dropdown>

    <!-- 详情页 -->
    <a-modal
        title="管理"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
    >
      <component :is="componentName"
                 :rowId="id"
                 ref="detailForm"
                 @cancelled="editModalVisible = false"
                 @saved="editModalVisible = false"
      ></component>
      <!--      <detailForm :rowId="id"-->
      <!--                  ref="detailForm"-->
      <!--                  @cancelled="editModalVisible = false"-->
      <!--                  @saved="editModalVisible = false">-->
      <!--      </detailForm>-->
    </a-modal>
  </div>

</template>

<script>
//接口API
import {dataApi} from '@/services/comm/ecTaskPromptManage';

export default {
  name: 'HeaderNotice',
  data() {
    return {
      loading: false,
      show: false,
      id: -1,
      editModalVisible: false,
      noticeCount: 0,
      noticeList: [],
      componentName: 'carOrderForm'
    }
  },
  mounted() {
    // dataApi.homePageNum().then((actionData) => {
    //   this.noticeCount = actionData.data;
    // }).catch(e => {
    //   this.$message.error(e.msg);
    // }).finally(() => {
    //   this.loading = false;
    // })
  },
  methods: {
    taskPromptDetail(row) {
      this.show = false;
      // if(this.$route.path === '/mall/carOrderManage'||this.$route.path === '/mall/ecGoodsParts'||this.$route.path === '/mall/serveGoodsManage'){
      //   this.$router.push('/workspace');
      // }
      // localStorage.setItem('X_GRID_KEY_ID', JSON.stringify(row.objId))
      if (row.objTypeId === 80001038) {
        this.componentName = 'carOrderForm'
        // this.$router.push('/mall/carOrderManage')
      } else if (row.objTypeId === 80001039) {
        this.componentName = 'ecGoodsPartsForm'
        // this.$router.push('/mall/ecGoodsParts')
      } else if (row.objTypeId === 80001040) {
        this.componentName = 'serveGoodsForm'
        // this.$router.push('/mall/serveGoodsManage')
      }
      this.id = row.objId;
      this.editModalVisible = true;
      // this.changeHasRead(row.taskId);
    },
    fetchNotice() {
      if (this.loading) {
        this.loading = false;
        return;
      }
      this.loading = true;

      dataApi.homePageData(10).then((actionData) => {
        this.loading = false;
        this.noticeList = actionData.data;
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.msg);
      });
    },
    changeHasRead(taskId) {
      this.show = false;
      dataApi.changeHasRead(taskId).then(() => {
      }).catch(e => {
        this.$message.error(e.msg);
      });

      dataApi.homePageNum().then((actionData) => {
        this.noticeCount = actionData.data;
      }).catch(e => {
        this.$message.error(e.msg);
      }).finally(() => {
      })
    }
  }
}
</script>


<style scoped>
.ant-list-item {
  cursor: pointer;
}
</style>
<style lang="less">
.header-notice {
  display: inline-block;
  transition: all 0.3s;

  span {
    vertical-align: initial;
  }

  .notice-badge {
    color: inherit;

    .header-notice-icon {
      font-size: 16px;
      padding: 4px;
    }
  }
}

.dropdown-tabs {
  background-color: @base-bg-color;
  box-shadow: 0 2px 8px @shadow-color;
  border-radius: 4px;

  .tab-pane {
    padding: 0 24px 12px;
    min-height: 250px;
  }
}
</style>
